import request from '@/utils/request'

export function uploadImage(data) { // 图片上传
    return request({
        url: 'basic/image',
        method: 'post',
        data
    })
}

export function uploadQiNiu() { // 上传七牛
    return request({
        url: '/basic/getUplodeToken',
        method: 'get'
    })
}
